import React from "react";
import { getEarnedBadges } from "../../utils/badges";
import "./BadgeList.css";

// compact: small inline pills for cards (TutorCard). Full: larger pills with
// labels for the profile page.
const BadgeList = ({ entity, compact = false, max }) => {
  const earned = getEarnedBadges(entity);
  if (earned.length === 0) return null;

  const shown = max ? earned.slice(0, max) : earned;
  const extra = max && earned.length > max ? earned.length - max : 0;

  return (
    <div className={`badge-list ${compact ? "badge-list--compact" : ""}`}>
      {shown.map((badge) => (
        <span
          key={badge.type}
          className="badge-pill"
          title={badge.label}
        >
          <span className="badge-pill-icon">{badge.icon}</span>
          {compact ? badge.shortLabel : badge.label}
        </span>
      ))}
      {extra > 0 && <span className="badge-pill badge-pill--more">+{extra}</span>}
    </div>
  );
};

export default BadgeList;
